import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_CHEVRON_UP: GlameraIconDefinition = {
  name: 'chevron-up',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-chevron-up-trail" d="m18 15-6-6-6 6"></path>
    <path class="glm-chevron-up-arrow" d="m18 15-6-6-6 6"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-chevron-up-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './chevron-up.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ChevronUpIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_CHEVRON_UP;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
